import { getMeta, setMeta } from '../offline/db';

const KEY = 'production:selected';

export function getSelectedProductionId() {
  return getMeta<string>(KEY);
}

export async function setSelectedProductionId(productionId: string) {
  await setMeta(KEY, productionId);
}
